import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSession } from '@/lib/SessionContext';
import { getPageAccess } from '@/lib/AuthSession';
import { Eye } from 'lucide-react';
import FinanceKalkulator from '../FinanceKalkulator';

export default function FinanceCalculator() {
  const navigate = useNavigate();
  const location = useLocation();
  const { member: currentMember } = useSession();

  // Guard: check page_access for the relevant access key
  useEffect(() => {
    if (!currentMember) return;
    const isMarketing = location.pathname.includes('/marketing');
    const accessKey = isMarketing ? 'marketing_invoices' : 'invoice_po';
    const access = getPageAccess(currentMember, accessKey);
    if (access === 'none') {
      navigate('/office');
    }
  }, [currentMember, navigate, location.pathname]);

  return (
    <div className="space-y-3 md:space-y-6 text-[#302621] pb-24 md:pb-8">
      
      <div className="flex flex-col gap-1 md:px-0 pt-2 md:pt-6">
        <h1 className="text-base md:text-xl font-bold text-[#1F2937] tracking-tight leading-tight">Pembuatan Invoice</h1>
        <p className="text-[9px] md:text-xs text-[#6B7280] font-normal leading-relaxed mt-0.5 md:mt-0">Rancang Invoice baru secara manual, hitung margin otomatis, dan kirim langsung ke Finance & Marketing.</p>
      </div>

      <div className="md:px-0">
        <div className="mb-4 md:mb-6 bg-[#F5F8FF] border border-[#BFDBFE] p-3 md:p-4 rounded-xl text-[10px] md:text-xs relative">
          <div className="absolute -top-[1px] -right-[1px] bg-[#F59E0B] text-white text-[8px] md:text-[10px] font-bold px-2 py-0.5 md:px-3 md:py-1 rounded-bl-xl rounded-tr-xl uppercase tracking-wider shadow-sm z-10">
            Akses Spesial Internal
          </div>
          <h4 className="font-bold text-[#1E3A8A] flex items-center gap-1.5 md:gap-2 text-[10px] md:text-sm mt-0.5 md:mt-0">
            <Eye className="w-3.5 h-3.5 md:w-4 md:h-4" /> Mode Satala
          </h4>
          <p className="text-[#2563EB] mt-1.5 md:mt-1 leading-relaxed text-[9px] md:text-xs">
            Hai! Di sini kamu bisa atur sendiri <strong className="font-bold">Biaya Jasa</strong>, <strong className="font-bold">HAKI</strong>, dan langsung lihat transparansi <strong className="font-bold">Margin Profit</strong> di setiap komponen racikan ya. Oh iya, kalau margin-nya minus nanti bakal otomatis nyala peringatannya, jadi tenang aja — aku bantu awasin!
          </p>
        </div>
        
        <div className="mt-4 md:mt-4">
          <FinanceKalkulator />
        </div>
      </div>

    </div>
  );
}
